import { render, staticRenderFns } from "./c-player.vue?vue&type=template&id=4f121640&scoped=true"
import script from "./c-player.vue?vue&type=script&lang=js"
export * from "./c-player.vue?vue&type=script&lang=js"
import style0 from "./c-player.vue?vue&type=style&index=0&id=4f121640&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f121640",
  null
  
)

export default component.exports